import { useEffect } from "react";
import MyContactDetails from "../../components/MyContactDetails";
import { trackPageViewV2 } from "../../../../services/analytics-adapter";

export default function MyContactDetailsPage() {
  useEffect(() => {
    trackPageViewV2({
      pageName: "More:My Contact Details",
      pageSubSection1: "More",
      pageSubSection2: "More:My Contact Details",
      pageCategory: "More",
    });
  }, []);
  return <MyContactDetails />;
}
